import { GetEmployeesActionTypes } from '../actionsTypes';

const initState = {
    counter: 10,
    employeesDetails: {},

    isGettingEmployees: false,
    employees: [],
    getEmployeesError: '',
};

const counterReducer = (state = initState, action) => {
    switch (action.type) {
        case 'INCREMENT_COUNT':
            return {
                ...state,
                counter: state.counter + 1
            };
        case 'INCREMENT_COUNT_TEN':
            return {
                ...state,
                counter: state.counter + 10
            };

        case 'DOUBLE_COUNT':
            return {
                ...state,
                counter: state.counter * 2
            };
        case 'DECREMENT_COUNT_TEN':
            return {
                ...state,
                counter: state.counter - 10
            };
        case 'DECREMENT_COUNT':
            return {
                ...state,
                counter: state.counter - 1
            };
        case 'RESET_COUNT':
            return {
                ...state,
                counter: 0
            };
        case GetEmployeesActionTypes.INPROGRESS:
            return {
                ...state,
                isGettingEmployees: true,
            };
        case GetEmployeesActionTypes.SUCCESS:
            return {
                ...state,
                employees: action.payload,
                isGettingEmployees: false,
            };
        case GetEmployeesActionTypes.FAILED:
            return {
                ...state,
                isGettingEmployees: false,
                getEmployeesError: action.error,
            };
        case GetEmployeesActionTypes.RESET_ERROR:
            return {
                ...state,
                getEmployeesError: '',
            };
        default:
            return state;
    }
};

export default counterReducer;